import { Feature, Point } from 'geojson'

import { GeoFence } from '@/feature/observatory'

export const getLongitudeLatitudeFromGeoFence = (geoFence: GeoFence): google.maps.LatLngLiteral => {
  const home = (geoFence.geoJson as Feature).properties?.home
  if (home) return home

  const coordinates = ((geoFence.geoJson as Feature).geometry as Point)?.coordinates
  if (coordinates && coordinates.length >= 2) {
    const [lng, lat] = coordinates
    return { lng, lat }
  }

  //other code depending on this utility should handle missing data checks
  //this is a failsafe and adheres to the google.maps.LatLngLiteral type
  console.error('Could not get coordinates from geoFence', geoFence)
  return { lng: NaN, lat: NaN }
}
